export const CAMPAIGNS_INDEX = 'CAMPAIGNS_INDEX'
export const CAMPAIGNS_INDEX_SUCCEEDED = 'CAMPAIGNS_INDEX_SUCCEEDED'
export const CAMPAIGN_SELECT_SUCCEEDED = 'CAMPAIGN_SELECT_SUCCEEDED'

export const CAMPAIGNS_FETCH_INDEX = 'CAMPAIGNS_FETCH_INDEX'
export const CAMPAIGNS_INDEX_FAILED = 'CAMPAIGNS_INDEX_FAILED'
export const CAMPAIGN_SELECT_FAILED = 'CAMPAIGN_SELECT_FAILED'
export const CAMPAIGN_SELECT_FETCH = 'CAMPAIGN_SELECT_FETCH'

export const campaignsIndexSucceeded = data =>
  ({ type: CAMPAIGNS_INDEX_SUCCEEDED, payload: data })

export const campaignsIndexFailed = action =>
  ({ type: CAMPAIGNS_INDEX_FAILED, payload: action })

export const campaignSelectedSucceeded = data =>
  ({ type: CAMPAIGN_SELECT_SUCCEEDED, payload: data })

export const campaignSelectedFailed = data =>
  ({ type: CAMPAIGN_SELECT_FAILED, payload: data })

export const loadCampaigns = () =>
  ({ type: CAMPAIGNS_FETCH_INDEX })

export const selectCampaign = ({ id }) =>
  ({ type: CAMPAIGN_SELECT_FETCH, payload: { id } })



// WEBPACK FOOTER //
// ./src/actions/campaigns.jsx